import { render } from "./SurveyQuestionOptions.vue?vue&type=template&id=9047cf70&scoped=true"
import script from "./SurveyQuestionOptions.vue?vue&type=script&lang=js"
export * from "./SurveyQuestionOptions.vue?vue&type=script&lang=js"

import "./SurveyQuestionOptions.vue?vue&type=style&index=0&id=9047cf70&lang=css&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9047cf70"]])

export default __exports__